/**
 * Angular 2 decorators and services
 */
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';

@Component({
  selector: 'modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

/**
 *
 * Modal Footer component.
 * @class ModalFooterComponent
 *
 */
export class ModalFooterComponent {
  @HostBinding('attr.e2e-attr')
  public e2eAttr: string = E2E_ATTRIBUTES.MODAL_FOOTER;
}
